import endpoint from '../web-sh/src/config/endpoint';
const API_URL = process.env.REACT_APP_API_URL;
const FLAT_FORM = `${API_URL}/v3/cystack_platform`;
const FLAT_FORM_PM = `${API_URL}/v3/cystack_platform/pm`;
const FLAT_FORM_RELAY = `${API_URL}/v3/cystack_platform/relay`;

const LWH_SKRAPP_URL = "https://lwh.skrapp.io"

export default {
  ...endpoint,
  SSO_ME: `${API_URL}/v3/sso/me`,
  ACCESS_TOKEN: `${API_URL}/v3/sso/access_token`,

  USERS_ME_DELETE: `${FLAT_FORM_PM}/users/me/delete`,
  USERS_ME_CHATWOOT: `${FLAT_FORM_PM}/users/me/chatwoot`,
  USERS_ME_ONBOARDING_PROCESS: `${FLAT_FORM_PM}/users/me/onboarding_process`,

  USERS_PASSWORD_HINT: `${FLAT_FORM_PM}/users/password_hint`,

  SUBDOMAINS: `${FLAT_FORM_RELAY}/subdomains`,
  SUBDOMAIN: `${FLAT_FORM_RELAY}/subdomains/:id`,
  USE_SUBDOMAIN: `${FLAT_FORM_RELAY}/subdomains/use_subdomain`,
  ADDRESSES: `${FLAT_FORM_RELAY}/addresses`,
  ADDRESS: `${FLAT_FORM_RELAY}/addresses/:id`,

  PAYMENTS_CARDS: `${FLAT_FORM}/payments/cards`,
  PAYMENTS_CARD: `${FLAT_FORM}/payments/cards/:id`,
  PAYMENTS_CARD_DETAIL: `${FLAT_FORM}/payments/cards/:id/detail`,

  PAYMENTS: `${FLAT_FORM_PM}/payments`,
  PAYMENTS_TRIAL: `${FLAT_FORM_PM}/payments/trial`,
  PAYMENTS_CALC: `${FLAT_FORM_PM}/payments/calc`,
  PAYMENTS_INVOICES: `${FLAT_FORM_PM}/payments/invoices`,
  PAYMENTS_PLAN: `${FLAT_FORM_PM}/payments/plan`,
  PAYMENTS_PLAN_LIMIT: `${FLAT_FORM_PM}/payments/plan/limit`,
  PAYMENTS_PLAN_CANCEL: `${FLAT_FORM_PM}/payments/plan/cancel`,

  FAMILY_MEMBERS: `${FLAT_FORM_PM}/family/members`,
  FAMILY_MEMBER: `${FLAT_FORM_PM}/family/members/:id`,

  ENTERPRISE_POLICY_MASTER_PASSWORD_REQUIREMENT: `${FLAT_FORM_PM}/enterprises/:enterprise_id/policy/master_password_requirement`,
  ENTERPRISE_MEMBERS_INVITATIONS: `${FLAT_FORM_PM}/enterprises/members/invitations`,
  ENTERPRISE_MEMBERS_INVITATION: `${FLAT_FORM_PM}/enterprises/members/invitations/:invitation_id`,

  REWARD_CLAIM: `${FLAT_FORM_PM}/reward/claim`,
  REWARD_CLAIM_PROMO_CODES: `${FLAT_FORM_PM}/reward/claim/promo_codes`,
  REWARD_MISSIONS: `${FLAT_FORM_PM}/reward/missions`,
  REWARD_MISSION: `${FLAT_FORM_PM}/reward/missions/:id`,
  REWARD_MISSION_COMPLETED: `${FLAT_FORM_PM}/reward/missions/:id/completed`,

  REFERRALS: `${FLAT_FORM_PM}/referrals`,

  RESOURCES_COUNTRIES: `${API_URL}/v3/resources/countries`,
  RESOURCES_PLANS: `${API_URL}/v3/resources/cystack_platform/pm/plans`,
  RESOURCES_BANNER: `${API_URL}/v3/resources/cystack_platform/pm/banner_data`,
  RESOURCES_LANG: `${API_URL}/v3/resources/lang`,

  SCAM_REPORTS: `${API_URL}/locker_scam_detector/v1/reports`,
  SCAM_SETTINGS: `${FLAT_FORM_PM}/scam_settings`,
  SCAM_SETTINGS_WHITELIST_URLS: `${FLAT_FORM_PM}/scam_settings/whitelist_urls`,
  COMPANY_SEARCH_PUBLIC: `${LWH_SKRAPP_URL}/company/search/public`,
  SCAM_REPORTS_IS_ANONYMOUS: `${API_URL}/locker_scam_detector/v1/reports/is_anonymous`,
};